<template>
  <div ref="searchModalRef" class="modal fade" id="searchModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-search modal-lg">
      <div class="modal-content position-relative">
        <div class="modal-header border-0 justify-content-center p-0">
          <p class="search-modal-title modal-title h2 fw-bold" id="exampleModalLabel">{{ title }}</p>
          <button type="button" class="btn-close position-absolute modal-search__btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body d-flex justify-content-center p-0 ">
          <div class="modal-search__controls d-flex flex-column flex-md-row align-items-center w-100">
            <Input
              v-model="searchValue"
              :shouldHaveSearchClear="true"
              :placeholder="placeholder"
              class="modal-input"
              @onInputEnterClick="redirectToResult"
            />
            <ButtonRed :text="btnText" class="modal-search__btn mt-4 mt-md-0 ms-md-4" @click="redirectToResult" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Input from '@/components/common/Input'
import ButtonRed from "@/components/common/ButtonRed";
import {useRouter} from "vue-router";
import { ref } from 'vue';

const router = useRouter();
const searchValue = ref('');

const redirectToResult = () => {
  window.location.href = `${window.location.origin}/search-results?keywords=${searchValue.value}`
  searchValue.value = '';
}

const props = defineProps({
  title: String,
  placeholder: String,
  btnText: String,
  href: String
})
</script>
